import React, {useState, useEffect } from "react";
import SingleVehicleTable from "../components/serviceHistoryComponents/SingleVehicleTable";
import { parseNba } from "../services/helpers/nbaHelper";
import NBAMultiVisitView from "../components/serviceHistoryComponents/NBAMultiVisitView";
import PDFModal from '../components/PdfModal'
import useLoading from "../hooks/useLoading";
import useShowMessages from "../hooks/useShowMessages";
import { createInspectionFile } from '../services/safetyCheckReportService';
import { getOrderPdf } from '../services/multivisitPDFService';
import useStore from "../hooks/useStore";

const NextBestAction = (props) => {
  const { vehicleNBA, selectedVehicle, returnToSearch, returnToResult } = props;
  const [ parsedVehicleNBA, setParsedVehicleNBA ] = useState({status: [], date: ''});
  const [ showPdf, setShowPdf ] = useState(false);
  const [ pdfData, setPdfData ] = useState();
  const { setIsLoading } = useLoading()
  const { showMessage } = useShowMessages();
  const { storeId } = useStore();

  const getPdfData = async (orderNumber, documentType, source) => {
    try {
        setIsLoading(true);
        let data = await getOrderPdf(orderNumber, documentType, storeId, source);

        if (data.isInvalid) {
            showMessage(data.description, "warning");
            setIsLoading(false);
            return;
        }
        setPdfData(data.document);
        setShowPdf(true);
        setIsLoading(false);
    } catch(error) {
        console.log(error);
        showMessage("An error ocurred trying to get the PDF document", "error")
        setIsLoading(false);
    }
  }

  const getPdfReport = async (store_Id, workOrderId, source) => {
      try{
          setIsLoading(true)
          let pdfDocument;
          const csData = await getOrderPdf(workOrderId, 'inspection', storeId, source);
          if (csData.isInvalid) {
            const sscData = await createInspectionFile(store_Id, workOrderId);
            pdfDocument = sscData.pdfData;
          }else{
            pdfDocument = csData.document;
          }
          
          setPdfData(pdfDocument);
          setIsLoading(false)
          setShowPdf(true)
      }
      catch(error){
          console.log(error);
          showMessage("An error ocurred trying to get the PDF document", "error")
          setIsLoading(false);
      }
  }

  useEffect (()=>{
    const parsed = parseNba(
      vehicleNBA,
      { getPdfData, getPdfReport },
    );
    setParsedVehicleNBA(parsed);
  },[vehicleNBA])


  return (
    <div className={'nextBestAction-container-multi-visit nextBestAction-container-btn'}>
      <SingleVehicleTable vehicleData={selectedVehicle} />      
      <NBAMultiVisitView vehicleNBA={parsedVehicleNBA} />
      <PDFModal open={showPdf} setShowPdf={setShowPdf} pdfData={pdfData} />
      <div className="buttons-nba">
        <button onClick={returnToResult}>Back</button>
        <button onClick={returnToSearch}>Close</button>
      </div>
    </div>
  );
}

export default NextBestAction;